import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { HomePage } from '@/pages/HomePage';
import { PlansPage } from '@/pages/PlansPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { CallbackPage } from '@/pages/auth/CallbackPage';
import { JobsPage } from '@/pages/dashboard/JobsPage';
import { CompanyPage } from '@/pages/dashboard/CompanyPage';
import { AnalyticsPage } from '@/pages/dashboard/AnalyticsPage';
import { SettingsPage } from '@/pages/dashboard/SettingsPage';
import { ApplicationsPage } from '@/pages/dashboard/ApplicationsPage';
import { CustomersPage } from '@/pages/admin/CustomersPage';
import { CustomerSubscriptionPage } from '@/pages/admin/CustomerSubscriptionPage';
import { CustomerSSOPage } from '@/pages/admin/CustomerSSOPage';
import { StatisticsPage } from '@/pages/admin/StatisticsPage';
import { SystemHealthPage } from '@/pages/admin/SystemHealthPage';
import { PermissionsPage } from '@/pages/admin/PermissionsPage';
import { JobCategoriesPage } from '@/pages/admin/JobCategoriesPage';
import { SkillsPage } from '@/pages/admin/SkillsPage';
import { EmailTemplatesPage } from '@/pages/admin/EmailTemplatesPage';
import { BotConfigPage } from '@/pages/admin/BotConfigPage';
import { ClaudeStatsPage } from '@/pages/admin/ClaudeStatsPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        
        {/* Dashboard routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard/jobs" replace />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="company" element={<CompanyPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="applications" element={<ApplicationsPage />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin" element={<DashboardLayout />}>
          <Route index element={<CustomersPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:customerId/subscription" element={<CustomerSubscriptionPage />} />
          <Route path="customers/:customerId/sso" element={<CustomerSSOPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="health" element={<SystemHealthPage />} />
          <Route path="permissions" element={<PermissionsPage />} />
          <Route path="categories" element={<JobCategoriesPage />} />
          <Route path="skills" element={<SkillsPage />} />
          <Route path="email-templates" element={<EmailTemplatesPage />} />
          <Route path="bot-config" element={<BotConfigPage />} />
          <Route path="claude-stats" element={<ClaudeStatsPage />} />
        </Route>

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;